import { IGetInvitableOnsiteInterviewsPayload } from '../../types';

export const factoryGetInvitableOnsiteInterviewsKey = (
  payload: IGetInvitableOnsiteInterviewsPayload,
) => ['GET_INVITABLE_ONSITE_INTERVIEWS', payload.postingId, payload.professionalId] as const;
